import { motion } from "framer-motion"
import labimage from "./lab-3498584_1280.jpg"
import "./about.css"

export default function Aboutus(){
    return <div className="aboutpage">
        <div className="aboutsection">
            <motion.div className="image-div" variants={{
                hidden:{opacity:0,x:"-10vw"},
                visible:{opacity:1,x:"0vw"}
            }} initial={"hidden"} animate={"visible"} transition={{duration:1,delay:0.25}}>
                <img className="profile-img" src={labimage} />
            </motion.div>
            <motion.div className="aboutdiv" variants={{
                hidden:{opacity:0,x:"10vw"},
                visible:{opacity:1,x:"0vw"}
            }} initial={"hidden"} animate={"visible"} transition={{duration:1,delay:0.25}}> 
            <div className="abouttitle">
                <h1>About Us</h1>
                <span className="line"/>
            </div>
                <p className="abouttxt">In 2020, during the Covid-19 pandemic, Saeed Ahmed Khan, a senior radiographer at Tabba Heart Institute, launched AHK Portable X-ray Service. He started this service with his son, Ahmed Hassan Khan, and together they performed over 1000 portable X-rays during the pandemic. AHK Portable X-ray Service established contracts with major labs and hospitals such as Essa Lab, Hashmani Labs, and Health Solutions. They collaborated to provide X-ray and lab services throughout Karachi. Currently, AHK Portable X-ray Service has set up digital X-ray facilities in hospitals like ZMT, Darul Shifa, and Lyfe Health Care, which are still operational today. Initially, they only offered X-ray services but have since expanded to include lab tests, ECG, and ultrasound services.</p>
            </motion.div>
        </div>
        <div className="aboutsection" style={{flexDirection:"row-reverse"}}>
            <motion.div className="image-div" variants={{
                hidden:{opacity:0,x:"-10vw"},
                visible:{opacity:1,x:"0vw"}
            }} initial={"hidden"} animate={"visible"} transition={{duration:1,delay:0.25}}>
                <img className="profile-img" src={labimage} />
            </motion.div>
            <motion.div className="aboutdiv" variants={{
                hidden:{opacity:0,x:"10vw"},
                visible:{opacity:1,x:"0vw"}
            }} initial={"hidden"} animate={"visible"} transition={{duration:1,delay:0.5}}> 
            <div className="abouttitle">
                <h1>Our Story</h1>
                <span className="line"/>
            </div>
                <p className="abouttxt">In 2020, during the Covid-19 pandemic, Saeed Ahmed Khan, a senior radiographer at Tabba Heart Institute, launched AHK Portable X-ray Service. He started this service with his son, Ahmed Hassan Khan, and together they performed over 1000 portable X-rays during the pandemic. AHK Portable X-ray Service established contracts with major labs and hospitals such as Essa Lab, Hashmani Labs, and Health Solutions. They collaborated to provide X-ray and lab services throughout Karachi. Currently, AHK Portable X-ray Service has set up digital X-ray facilities in hospitals like ZMT, Darul Shifa, and Lyfe Health Care, which are still operational today. Initially, they only offered X-ray services but have since expanded to include lab tests, ECG, and ultrasound services.</p>
            </motion.div>
        </div>

    </div>
}